module.exports = __webpack_public_path__ + "img/welcome-dashboard-3.803da180.png";